<template>
    <h1>Color Wheel</h1>

    <div>
        <svg :id="chartId"></svg>
    </div>
</template>

<script>

import * as d3 from "d3";

export default {
    name: 'ColorWheel',
    props: ['chartData', 'chartId'],
    data() {
        return {
            model: {}
        }
    },
    mounted() {
        // let name = ([x]) => x;  // given d in data, returns the (ordinal) label
        // let value = ([, y]) => y; // given d in data, returns the (quantitative) value

        let name = d => d.name;
        let value = d => d.value;
        let colorsFunction = d => d.colorValue;
        let title; // given d in data, returns the title text
        let width = 640; // outer width, in pixels
        let height = 400; // outer height, in pixels
        let innerRadius = 0 // inner radius of pie, in pixels (non-zero for donut)
        let outerRadius = Math.min(width, height) / 2; // outer radius of pie, in pixels
        let labelRadius = (innerRadius * 0.2 + outerRadius * 0.8); // center radius of labels
        let format = ","; // a format specifier for values (in the label)
        let names; // array of names (the domain of the color scale)
        let colors; // array of colors for names
        let stroke = innerRadius > 0 ? "none" : "white"; // stroke separating widths
        let strokeWidth = 1; // width of stroke separating wedges
        let strokeLinejoin = "round"; // line join of stroke separating wedges
        let padAngle = stroke === "none" ? 1 / outerRadius : 0; // angular separation between wedges

        // Compute values.
        const N = d3.map(this.chartData, name);
        const V = d3.map(this.chartData, value);
        const I = d3.range(N.length).filter(i => !isNaN(V[i]));

        // Unique the names.
        if (names === undefined) names = N;
        names = new d3.InternSet(names);

        // Chose a default color scheme based on cardinality.
        // if (colors === undefined) colors = d3.schemeSpectral[names.size];
        // if (colors === undefined) colors = d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), names.size);
        colors = d3.map(this.chartData, colorsFunction);

        // Construct scales.
        const color = d3.scaleOrdinal(names, colors);

        // Compute titles.
        if (title === undefined) {
            const formatValue = d3.format(format);
            // title = i => `${N[i]}\n${formatValue(V[i])}`;
            title = i => `${N[i]}`;
        } else {
            const O = d3.map(data, d => d);
            const T = title;
            title = i => T(O[i], i, data);
        }

        // Construct arcs.
        const arcs = d3.pie().padAngle(padAngle).sort(null).value(i => V[i])(I);
        const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
        const arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius);

        const svg = d3.select("#" + this.chartId)
                .attr("width", width)
                .attr("height", height)
                .attr("viewBox", [-width / 2, -height / 2, width, height])
                .attr("style", "max-width: 100%; height: auto; height: intrinsic;");

        svg.append("g")
                .attr("stroke", stroke)
                .attr("stroke-width", strokeWidth)
                .attr("stroke-linejoin", strokeLinejoin)
                .selectAll("path")
                .data(arcs)
                .join("path")
                .attr("fill", d => color(N[d.data]))
                .attr("d", arc)
                .append("title")
                .text(d => title(d.data));

        svg.append("g")
                .attr("font-family", "sans-serif")
                .attr("font-size", 10)
                .attr("text-anchor", "middle")
                .selectAll("text")
                .data(arcs)
                .join("text")
                .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
                .selectAll("tspan")
                .data(d => {
                    const lines = `${title(d.data)}`.split(/\n/);
                    return (d.endAngle - d.startAngle) > 0.25 ? lines : lines.slice(0, 1);
                })
                .join("tspan")
                .attr("x", 0)
                .attr("y", (_, i) => `${i * 1.1}em`)
                .attr("font-weight", (_, i) => i ? null : "bold")
                .text(d => d);

    },
    methods: {
        importantMethodHere() {
        }
    }
}
</script>
